const EMPTY_STATUS_CONSTANTS = {
    ILLUSTRATION_PROPS: {
        ariaHidden: 'false',
        altText: 'illustration',
    },
};
export { EMPTY_STATUS_CONSTANTS };
//# sourceMappingURL=empty-status.constants.js.map